import { Component, ViewChild, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators, ValidatorFn, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';

import { DbService } from '../../../db.service';
import { SessionService } from '../../../session.service';
import { SpinnerService } from '../../../spinner.service';

import { Cadastro } from './cadastro.class';
import { Carrinho, RetornoAssinar } from './carrinho.class';
import { Municipio } from './municipio.class';
import { Produto } from './produto.class';
import { UF } from './uf.class';
import { Atividade } from './atividade.class';
import { Comprovante } from './comprovante.class';

import { AppLoginModalComponent } from '../../app-login/app-login.component'

import { Price } from '../../shared/price-selection/model/price.class'
import { Item } from '../../shared/listbox/model/item.class';

import * as _ from 'lodash';

@Component({
    selector: 'app-sobre-planos',
    templateUrl: './planos.component.html',
    styleUrls: ['./planos.component.css']
})

export class Sobre_PlanosComponent {
    @ViewChild("login") login: AppLoginModalComponent;
    private readonly CONTEXTO_COMPRA_KEY = 'planos_compra_context';
    private readonly OTP_SUCCESS_KEY = 'planos_otp_success';

    private url_Cep : string = "https://viacep.com.br/ws/";
    enviado: string = '';
    carrinho        : Carrinho[] = [];
    etapa           : number = 1;
    etapa_erro: number = 0;
    etapa_produto: number = 0;
    etapa_progress: number = 20;
    copy_text: boolean = false;
    form_etapa1: FormGroup;
    form_etapa2_1: FormGroup;
    form_etapa2_1_1: FormGroup;
    form_etapa2_2: FormGroup;
    form_etapa2_2_1: FormGroup;
    form_etapa2_2_2: FormGroup;
    form_etapa3: FormGroup;
    form_etapa_termos: FormGroup;
    index_produto: number = 0;
    item: Cadastro = new Cadastro();
    idPedido: string = '';
    lista_atividade: Atividade[] = [];
    lista_atividade_filtro: Atividade[] = [];
    produto1_lista_itens_origem: Item[] = [];
    produto1_lista_itens_destino: Item[] = [];
    produto1_lista_precos: Price[] = [];
    produto1_precoSelecionado: Price = new Price();
    produto1_validaMunicipio: boolean = true;
    produto1_validaPreco: boolean = true;
    produto1_tipoPesquisa: string = '1';
    produto2_tipoNegociacao: string = '2';
    lista_produto: Produto[] = [];
    lista_tipoNegociacao: Array<{ text: string, value: string }> = [
        { text: "Boletim Salariômetro", value: "5" },
        { text: "Negociação Coletiva Básica", value: "7" },
        { text: "Negociação Coletiva Completa", value: "2" },
        { text: "Negociação Coletiva Premium", value: "3" }
    ];
    lista_vigencia_produto2: Array<{ text: string, value: number }> = [
        { text: "12 Meses", value: 3 }
    ];
    lista_uf: UF[] = [];
    lista_uf_filtro: UF[] = [];
    lista_uf_filtro1: UF[] = [];
    mask: string = "(00) 0000-00009";
    maskDocumento: string = "000.000.000-00";
    progress_step: number = 20;
    retorno_assinar: RetornoAssinar = new RetornoAssinar();
    show_pagamento: boolean = false;
    vigencia_produto1: string = '';
    vigencia_produto2: string = '';
    emailExistente: boolean = false;

    // Confirmação dos dados fiscais (usuário autenticado). Os dados são os mesmos do cadastro
    // (Cliente/AreaAssinante e Cliente/AtualizarDadosCadastrais); credenciais de acesso não são alteradas.
    private readonly CONTROLES_FISCAIS = [
        'pessoal_nmCliente', 'pessoal_cdDocumento', 'pessoal_nuDocumento', 'pessoal_dsOrganizacao',
        'pessoal_dsCEP', 'pessoal_dsEndereco', 'pessoal_dsNumero', 'pessoal_dsComplemento',
        'pessoal_dsBairro', 'pessoal_dsMunicipio', 'pessoal_dsEstado'
    ];
    private emailCadastro: string = '';
    private dadosFiscaisBackup: any = null;
    fiscal_carregando: boolean = false;
    fiscal_carregado: boolean = false;
    fiscal_editando: boolean = false;
    fiscal_salvando: boolean = false;
    fiscal_confirmado: boolean = false;
    fiscal_tentouAvancar: boolean = false;
    fiscal_erro: string = '';

    constructor(
        private dbService: DbService,
        private router: Router,
        private sessionService: SessionService,
        private spinnerService: SpinnerService,
    ) {

        this.form_etapa1 = new FormGroup({
            produtos: new FormControl('', Validators.required)
        });

        this.form_etapa2_1 = new FormGroup({
            idVigencia: new FormControl('', Validators.required),
            municipioTodos: new FormControl(''),
            tipoPesquisa: new FormControl('1'),
            municipioSelecionados: new FormControl('', this.ValidaProduto1())
        });

        this.form_etapa2_1_1 = new FormGroup({
            cdUf: new FormControl('', Validators.required),
            cdMunicipio: new FormControl('', Validators.required)
        });

        this.form_etapa2_2 = new FormGroup({
            ufTodos: new FormControl(''),
            ufSelecionados: new FormControl('', this.ValidaProduto2(1)),
            atividadeTodos: new FormControl(''),
            negociacaoPersonalizada: new FormControl(''),
            tipoNegociacao: new FormControl('2', Validators.required),
            atividadeSelecionados: new FormControl('', this.ValidaProduto2(2))
        });
        
        // Garante que o valor inicial seja sempre "2" (Negociação Coletiva Completa)
        this.item.produto2_tipoNegociacao = '2';
        this.form_etapa2_2.patchValue({ tipoNegociacao: '2' });

        this.form_etapa2_2_1 = new FormGroup({
            cdUf: new FormControl('', Validators.required)
        });

        this.form_etapa2_2_2 = new FormGroup({
            idAtividade: new FormControl('', Validators.required)
        });

        this.form_etapa3 = new FormGroup({
            pessoal_nmCliente     : new FormControl('', Validators.required),
            pessoal_cdDocumento   : new FormControl('', Validators.required),
            pessoal_nuDocumento   : new FormControl('', this.ValidaCPFCNPJ()),
            pessoal_dsOcupacao    : new FormControl('', Validators.required),
            pessoal_dsOrganizacao : new FormControl('', Validators.required),
            pessoal_dsCEP         : new FormControl('', Validators.required),
            pessoal_dsEndereco    : new FormControl('', Validators.required),
            pessoal_dsNumero      : new FormControl('', Validators.required),
            pessoal_dsComplemento : new FormControl(''),
            pessoal_dsBairro      : new FormControl(''),
            pessoal_dsMunicipio   : new FormControl('', Validators.required),
            pessoal_dsEstado      : new FormControl('', Validators.required),
            pessoal_nuTelefone    : new FormControl('', Validators.required),
            pessoal_dsEmail       : new FormControl('', { validators: [Validators.required, Validators.email], asyncValidators: this.ValidaEmail(), updateOn: 'blur' }),
            pessoal_cdSenha       : new FormControl('', Validators.required)
        });

        this.form_etapa_termos = new FormGroup({
            aceiteTermos: new FormControl('', Validators.required)
        });

        // Carrega combos
        this.load();

        // Verifica se houve alteração que necessita cálculo
        this.item.alteracao_produto1_municipioTodos.subscribe(() => {
            this.fnCalcular();
        });
        this.item.alteracao_produto1_tipoPesquisa.subscribe(() => {
            this.fnCalcularProduto1(this.produto1_lista_itens_destino);
        });
        this.item.alteracao_produto2_ufTodos.subscribe(() => {
            this.fnCalcular();
        });
        this.item.alteracao_produto2_uf.subscribe(() => {
            this.fnCalcular();
        });
        this.item.alteracao_produto2_atividadeTodos.subscribe(() => {
            this.fnCalcular();
        });
        this.item.alteracao_produto2_negociacaoPersonalizada.subscribe(() => {
            this.fnCalcular();
        });
        this.item.alteracao_produto2_atividade.subscribe(() => {
            this.fnCalcular();
        });

        this.item.alteracao_produto2_tipoNegociacao.subscribe(() => {
            this.fnCalcular();
            // Atualiza validadores quando o tipo de negociação mudar
            if (this.item.produto2_tipoNegociacao === '5') {
                // Boletim: remove validadores de estado e atividade
                this.form_etapa2_2.controls['ufSelecionados'].clearValidators();
                this.form_etapa2_2.controls['ufSelecionados'].updateValueAndValidity();
                this.form_etapa2_2.controls['atividadeSelecionados'].clearValidators();
                this.form_etapa2_2.controls['atividadeSelecionados'].updateValueAndValidity();
            } else {
                // Outros tipos: restaura validadores
                this.form_etapa2_2.controls['ufSelecionados'].setValidators(this.ValidaProduto2(1));
                this.form_etapa2_2.controls['ufSelecionados'].updateValueAndValidity();
                this.form_etapa2_2.controls['atividadeSelecionados'].setValidators(this.ValidaProduto2(2));
                this.form_etapa2_2.controls['atividadeSelecionados'].updateValueAndValidity();
            }
        });

        // Garante que a sessão seja carregada
        this.sessionService.fnInicializarSessao();
        
        // Se está autenticado, pula tela de login
        if (this.sessionService.usuario.hash !== '') {
            this.etapa_progress = 25;
            this.progress_step = 25;
            this.item.pessoal_hash = this.sessionService.usuario.hash;
        }

        // Calcula vigência da negocição coletiva
        let data_atual: Date = new Date();
        let data_fim: Date = new Date(data_atual.setMonth(data_atual.getMonth() + 12));
        this.vigencia_produto2 = 
            'Comprando hoje, você terá acesso até ' + 
            (data_fim.getDate() < 10 ? '0' + data_fim.getDate() : data_fim.getDate()) + '/' + 
            ((data_fim.getMonth() + 1) < 10 ? '0' + (data_fim.getMonth() + 1) : (data_fim.getMonth() + 1)) + '/' + 
            data_fim.getFullYear();

        this.fnTratarRetornoOtp();
    }

    private fnAbrirLoginCompra(): void {
        this.fnSalvarContextoCompra();
        this.login.fnShow('planos', 1, this.item.pessoal_dsEmail);
    }

    private fnSalvarContextoCompra(): void {
        const contexto = {
            etapa: this.etapa,
            etapa_progress: this.etapa_progress,
            etapa_produto: this.etapa_produto,
            index_produto: this.index_produto,
            carrinho: this.carrinho,
            produto1_lista_itens_destino: this.produto1_lista_itens_destino,
            produto1_precoSelecionado: this.produto1_precoSelecionado,
            emailExistente: this.emailExistente,
            item: {
                pessoal_nmCliente: this.item.pessoal_nmCliente,
                pessoal_cdDocumento: this.item.pessoal_cdDocumento,
                pessoal_nuDocumento: this.item.pessoal_nuDocumento,
                pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
                pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
                pessoal_dsCEP: this.item.pessoal_dsCEP,
                pessoal_dsEndereco: this.item.pessoal_dsEndereco,
                pessoal_dsNumero: this.item.pessoal_dsNumero,
                pessoal_dsComplemento: this.item.pessoal_dsComplemento,
                pessoal_dsBairro: this.item.pessoal_dsBairro,
                pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
                pessoal_dsEstado: this.item.pessoal_dsEstado,
                pessoal_nuTelefone: this.item.pessoal_nuTelefone,
                pessoal_icTermo: this.item.pessoal_icTermo,
                produto_selecionado: this.item.produto_selecionado,
                produto1_municipioTodos: this.item.produto1_municipioTodos,
                produto1_tipoPesquisa: this.item.produto1_tipoPesquisa,
                produto1_itensSelecionados: this.produto1_lista_itens_destino,
                produto2_ufTodos: this.item.produto2_ufTodos,
                produto2_ufSelecionados: this.item.produto2_ufSelecionados,
                produto2_atividadeTodos: this.item.produto2_atividadeTodos,
                produto2_atividadeSelecionados: this.item.produto2_atividadeSelecionados,
                produto2_negociacaoPersonalizada: this.item.produto2_negociacaoPersonalizada,
                produto2_tipoNegociacao: this.item.produto2_tipoNegociacao,
                produto2_idVigencia: this.item._produto2_idVigencia
            }
        };

        sessionStorage.setItem(this.CONTEXTO_COMPRA_KEY, JSON.stringify(contexto));
    }

    private fnRestaurarContextoCompra(): void {
        try {
            const raw = sessionStorage.getItem(this.CONTEXTO_COMPRA_KEY);
            if (!raw) { return; }

            const contexto = JSON.parse(raw);
            if (!contexto || !contexto.item) { return; }

            this.etapa = contexto.etapa || this.etapa;
            this.etapa_progress = contexto.etapa_progress || this.etapa_progress;
            this.etapa_produto = contexto.etapa_produto || this.etapa_produto;
            this.index_produto = contexto.index_produto || this.index_produto;
            this.carrinho = contexto.carrinho || this.carrinho;
            this.produto1_lista_itens_destino = contexto.produto1_lista_itens_destino || this.produto1_lista_itens_destino;
            this.emailExistente = contexto.emailExistente === true;

            this.item.pessoal_nmCliente = contexto.item.pessoal_nmCliente || '';
            this.item.pessoal_cdDocumento = contexto.item.pessoal_cdDocumento || '1';
            this.item.pessoal_nuDocumento = contexto.item.pessoal_nuDocumento || '';
            this.item.pessoal_dsOcupacao = contexto.item.pessoal_dsOcupacao || '';
            this.item.pessoal_dsOrganizacao = contexto.item.pessoal_dsOrganizacao || '';
            this.item.pessoal_dsCEP = contexto.item.pessoal_dsCEP || '';
            this.item.pessoal_dsEndereco = contexto.item.pessoal_dsEndereco || '';
            this.item.pessoal_dsNumero = contexto.item.pessoal_dsNumero || '';
            this.item.pessoal_dsComplemento = contexto.item.pessoal_dsComplemento || '';
            this.item.pessoal_dsBairro = contexto.item.pessoal_dsBairro || '';
            this.item.pessoal_dsMunicipio = contexto.item.pessoal_dsMunicipio || '';
            this.item.pessoal_dsEstado = contexto.item.pessoal_dsEstado || '';
            this.item.pessoal_nuTelefone = contexto.item.pessoal_nuTelefone || '';
            this.item.pessoal_dsEmail = '';
            this.item.pessoal_cdSenha = '';
            this.item.pessoal_icTermo = contexto.item.pessoal_icTermo === true;

            this.item.produto_selecionado = contexto.item.produto_selecionado || [];
            this.item.produto1_municipioTodos = contexto.item.produto1_municipioTodos || '1';
            this.item.produto1_tipoPesquisa = contexto.item.produto1_tipoPesquisa || '1';
            this.item.produto1_municipioSelecionados = contexto.item.produto1_itensSelecionados || [];

            this.item.produto2_ufTodos = contexto.item.produto2_ufTodos || '1';
            this.item.produto2_ufSelecionados = contexto.item.produto2_ufSelecionados || [];
            this.item.produto2_atividadeTodos = contexto.item.produto2_atividadeTodos || '1';
            this.item.produto2_atividadeSelecionados = contexto.item.produto2_atividadeSelecionados || [];
            this.item.produto2_negociacaoPersonalizada = contexto.item.produto2_negociacaoPersonalizada === true;
            this.item.produto2_tipoNegociacao = contexto.item.produto2_tipoNegociacao || '2';
            this.item._produto2_idVigencia = contexto.item.produto2_idVigencia || 3;

            this.form_etapa3.patchValue({
                pessoal_nmCliente: this.item.pessoal_nmCliente,
                pessoal_cdDocumento: this.item.pessoal_cdDocumento,
                pessoal_nuDocumento: this.item.pessoal_nuDocumento,
                pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
                pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
                pessoal_dsCEP: this.item.pessoal_dsCEP,
                pessoal_dsEndereco: this.item.pessoal_dsEndereco,
                pessoal_dsNumero: this.item.pessoal_dsNumero,
                pessoal_dsComplemento: this.item.pessoal_dsComplemento,
                pessoal_dsBairro: this.item.pessoal_dsBairro,
                pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
                pessoal_dsEstado: this.item.pessoal_dsEstado,
                pessoal_nuTelefone: this.item.pessoal_nuTelefone,
                pessoal_dsEmail: '',
                pessoal_cdSenha: ''
            });

            // Reaplica o preço selecionado por último para evitar que os gatilhos
            // de restore (ex.: tipoPesquisa) zerem o valor durante a restauração.
            if (contexto.produto1_precoSelecionado && typeof contexto.produto1_precoSelecionado.valor === 'number') {
                this.produto1_precoSelecionado = Object.assign(new Price(), contexto.produto1_precoSelecionado);
            } else {
                this.produto1_precoSelecionado = new Price();
            }

            this.cbxDocumento_Changed();
            this.tbxTelefone_Changed();

        } catch (e) {
            // Ignora contexto inválido e segue fluxo padrão.
        }
    }

    private fnTratarRetornoOtp(): void {
        const retornouDoOtp = sessionStorage.getItem(this.OTP_SUCCESS_KEY) === '1';
        if (!retornouDoOtp) {
            return;
        }

        sessionStorage.removeItem(this.OTP_SUCCESS_KEY);
        this.fnRestaurarContextoCompra();

        this.emailExistente = false;

        const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario'));
        if (sessao && sessao.hash) {
            this.item.pessoal_hash = sessao.hash;
        }

        // Após validar OTP no meio da compra, retoma a partir da conferência dos dados fiscais
        // (ou direto nos termos, quando não se aplica), mantendo o restante do fluxo já preenchido.
        this.fnRetomarAposAutenticacao();

        if (this.etapa === 4 && !this.requerTermos()) {
            this.etapa = 5;
            this.etapa_progress = 100;
        }

        sessionStorage.removeItem(this.CONTEXTO_COMPRA_KEY);
    }

    load() {
        this.dbService.get('Produto').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.lista_produto = result;
        });

        this.dbService.get('UF/GetAssinatura').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.lista_uf =
            this.lista_uf_filtro =
            this.lista_uf_filtro1 = result;
        });

        this.dbService.get('Atividade/GetAssinatura').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.lista_atividade =
            this.lista_atividade_filtro = result;
        });

        this.dbService.get('Assinatura/GetItemUfMunicipio').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            this.produto1_lista_itens_origem = result;
            // Guarda objetos
            //this.produto1_lista_itens_origem = _.cloneDeep(result);
            //this.produto1_lista_itens_origem = result
        });

        let temp = {          
            produto1_municipioTodos: "1",
            produto1_tipoPesquisa: '1',
            produto1_itensSelecionados: []
        };

        this.dbService.post<Price[]>('Assinatura/CalculaPrecosProduto1', temp).subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.produto1_lista_precos = result
        });
    }

    onPriceSelected(price: Price) {
        this.produto1_precoSelecionado = price;
    }

    onPriceDeselected() {
        this.produto1_precoSelecionado = null;
    }

    onTipoNegociacaoChange(value: string) {
        // Se o valor for vazio ou null, define como "2" (Negociação Coletiva Completa)
        if (!value || value === '' || value === null) {
            this.item.produto2_tipoNegociacao = '2';
            this.form_etapa2_2.patchValue({ tipoNegociacao: '2' }, { emitEvent: false });
        }
    }

    selecionarTipoNegociacao(value: string) {
        this.item.produto2_tipoNegociacao = value;
        this.form_etapa2_2.patchValue({ tipoNegociacao: value });
        this.form_etapa2_2.get('tipoNegociacao').markAsTouched();
        this.onTipoNegociacaoChange(value);
    }

    cmbProduto2Atividade_Changed(value: any): void {
        this.etapa_erro = 0;
    }

    cmbProduto2Atividade_Filter(value) {
        this.lista_atividade_filtro = this.lista_atividade.filter((s) => s.dsAtividade.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    cmbProduto2UF_Changed(value: any): void {
        this.etapa_erro = 0;
    }

    cmbProduto2UF_Filter(value) {
        this.lista_uf_filtro1 = this.lista_uf.filter((s) => s.nmUf.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    fnCalcular() {
        let temp = {
            produto_selecionado: this.item.produto_selecionado,            
            produto2_ufTodos: this.item.produto2_ufTodos,
            produto2_ufSelecionados: this.item._produto2_ufSelecionados,
            produto2_atividadeTodos: this.item.produto2_atividadeTodos,
            produto2_negociacaoPersonalizada: this.item.produto2_negociacaoPersonalizada,
            produto2_atividadeSelecionados: this.item._produto2_atividadeSelecionados,
            produto2_idVigencia: this.item._produto2_idVigencia,
            produto2_tipoNegociacao: this.item.produto2_tipoNegociacao
        };

        this.dbService.post('Assinatura/Calcular', temp).subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            if (result.confirmacao === true) {
                this.item._produto2_valor = result.valor_produto2;
            }
        });
    }

    fnCalcularProduto1(itens: Item[]) {
        this.produto1_lista_itens_destino = itens;
        this.onPriceSelected(new Price());

        let temp = {
            produto1_municipioTodos: this.item.produto1_municipioTodos,          
            produto1_itensSelecionados: itens,
            produto1_tipoPesquisa: this.item.produto1_tipoPesquisa,
        };

        this.dbService.post<Price[]>('Assinatura/CalculaPrecosProduto1', temp).subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();
            this.produto1_lista_precos = result;
        });
    }

    fnObtemListaOrigem(itens: Item[]) {
        this.produto1_lista_itens_origem = itens;
    }

    fnCopyText(){
        var content = (document.getElementById('chave_pix') as HTMLInputElement).value;
        //navigator.clipboard.writeText(content);
        this.copy_text = true;
        return;
    }

    onSelectionOpcaoChange(opcao: string) {
        let temp = {          
            produto1_municipioTodos: this.item.produto1_municipioTodos,
            produto1_tipoPesquisa: this.item.produto1_tipoPesquisa,
            produto1_itensSelecionados: []
        };

        if (this.item.produto1_municipioTodos === '1') {
            
            this.produto1_lista_itens_destino = [];
            this.dbService.get('Assinatura/GetItemUfMunicipio').subscribe(result => {
                // Encerra spinner
                this.spinnerService.stop();
    
                // Guarda objetos
                this.produto1_lista_itens_origem = result
            });
        }

        this.dbService.post<Price[]>('Assinatura/CalculaPrecosProduto1', temp).subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.produto1_lista_precos = result
        });


    }

    fnEtapaAvancar() {
        switch (this.etapa) {
            case 1: // Seleção do produto
                if (this.item.produto_selecionado.length === 0) {
                    for (let ctrl in this.form_etapa1.controls) { this.form_etapa1.controls[ctrl].markAsTouched(); }
                    return;
                } else {
                    for (let ctrl in this.form_etapa1.controls) { 
                        this.form_etapa1.controls[ctrl].markAsPristine();
                        this.form_etapa1.controls[ctrl].markAsUntouched();
                    }
                }
                break;

            case 2: // Seleção dos parâmetros
                if (this.etapa_produto === 1) {
                    if (this.item.produto1_municipioTodos === '0' && this.produto1_lista_itens_destino.length == 0) {
                        return;
                    }
                        
                    if (this.produto1_precoSelecionado.valor === 0 || this.produto1_precoSelecionado === null) {
                        return;
                    }

                    var posicao = this.carrinho.findIndex((s) => s.idProduto === this.etapa_produto);
                    if (posicao >= 0) {
                        this.carrinho.splice(posicao, 1);
                    }

                    let _carrinho = new Carrinho();
                    _carrinho.idProduto = this.etapa_produto;
                    _carrinho.dsProduto = this.obterNomeProdutoSelecionado(this.etapa_produto);
                    _carrinho.valor = this.produto1_precoSelecionado.valor;
                    this.carrinho.push(_carrinho);
                }

                if (this.etapa_produto === 2) {
                    // Se for Boletim (value="5"), não valida estado e atividade
                    if (this.item.produto2_tipoNegociacao !== '5') {
                        this.form_etapa2_2.controls['ufSelecionados'].updateValueAndValidity();
                        this.form_etapa2_2.controls['atividadeSelecionados'].updateValueAndValidity();
                    } else {
                        // Para Boletim, limpa as validações de estado e atividade
                        this.form_etapa2_2.controls['ufSelecionados'].clearValidators();
                        this.form_etapa2_2.controls['ufSelecionados'].updateValueAndValidity();
                        this.form_etapa2_2.controls['atividadeSelecionados'].clearValidators();
                        this.form_etapa2_2.controls['atividadeSelecionados'].updateValueAndValidity();
                    }

                    // Valida apenas o tipoNegociacao quando for Boletim
                    if (this.item.produto2_tipoNegociacao === '5') {
                        if (!this.form_etapa2_2.get('tipoNegociacao').valid) {
                            this.form_etapa2_2.get('tipoNegociacao').markAsTouched();
                            return;
                        }
                    } else if (!this.form_etapa2_2.valid) {
                        for (let ctrl in this.form_etapa2_2.controls) { this.form_etapa2_2.controls[ctrl].markAsTouched(); }
                        return;
                    }

                    if (this.form_etapa2_2.valid || this.item.produto2_tipoNegociacao === '5') {
                        var posicao = this.carrinho.findIndex((s) => s.idProduto === this.etapa_produto);
                        if (posicao >= 0) {
                            this.carrinho.splice(posicao, 1);
                        }

                        let _carrinho = new Carrinho();
                        _carrinho.idProduto = this.etapa_produto;
                        _carrinho.dsProduto = this.obterNomeProdutoSelecionado(this.etapa_produto);
                        _carrinho.valor = this.item._produto2_valor;
                        this.carrinho.push(_carrinho);
                    }
                }
                break;

            case 3: // Cadastro (ou conferência dos dados fiscais, quando autenticado)
                if (this.exigeConfirmacaoFiscal()) {
                    if (!this.fnPodeAvancarDadosFiscais()) {
                        return;
                    }
                    break;
                }

                if (!this.form_etapa3.valid) {
                    for (let ctrl in this.form_etapa3.controls) { this.form_etapa3.controls[ctrl].markAsTouched(); }
                    return;
                }

                if (this.item.produto_selecionado[0] !== 4 && !this.fiscal_confirmado) {
                    this.fiscal_tentouAvancar = true;
                    return;
                }
                
                // Verifica se o e-mail já existe e força o login
                if (this.emailExistente) {
                    this.fnAbrirLoginCompra();
                    return;
                }
                break;

            case 4: // Aceite dos termos
                if (this.requerTermos() && !this.item.pessoal_icTermo) {
                    return;
                }
                break;

            case 5: // Pagamento e geração do pedido
                // Verifica os termos apenas se o produto requer
                if (this.requerTermos() && !this.item.pessoal_icTermo) {
                    this.etapa = 4;
                    this.etapa_progress = 80;
                    return;
                }

                // Cadastra cliente
                let temp = {
                    pessoal_hash          : this.item.pessoal_hash,
                    pessoal_nmCliente     : this.item.pessoal_nmCliente,
                    pessoal_cdDocumento   : this.item.pessoal_cdDocumento,
                    pessoal_nuDocumento   : this.item.pessoal_nuDocumento,
                    pessoal_dsOcupacao    : this.item.pessoal_dsOcupacao,
                    pessoal_dsOrganizacao : this.item.pessoal_dsOrganizacao,
                    pessoal_dsCEP         : this.item.pessoal_dsCEP,
                    pessoal_dsEndereco    : this.item.pessoal_dsEndereco,
                    pessoal_dsNumero      : this.item.pessoal_dsNumero,
                    pessoal_dsComplemento : this.item.pessoal_dsComplemento,
                    pessoal_dsBairro      : this.item.pessoal_dsBairro,
                    pessoal_dsMunicipio   : this.item.pessoal_dsMunicipio,
                    pessoal_dsEstado      : this.item.pessoal_dsEstado,
                    pessoal_nuTelefone    : this.item.pessoal_nuTelefone,
                    pessoal_dsEmail       : this.item.pessoal_dsEmail,
                    pessoal_cdSenha       : this.item.pessoal_cdSenha,
                    produto_selecionado   : this.item.produto_selecionado,
                    produto1_municipioTodos: this.item.produto1_municipioTodos,
                    produto1_itensSelecionados: this.produto1_lista_itens_destino,
                    produto1_precoSelecionado: this.produto1_precoSelecionado,
                    produto1_tipoPesquisa: this.item.produto1_tipoPesquisa,
                    produto2_ufTodos: this.item.produto_selecionado[0] === 3? '1' : this.item.produto2_ufTodos,
                    produto2_ufSelecionados: this.item._produto2_ufSelecionados,
                    produto2_atividadeTodos: this.item.produto_selecionado[0] === 3? '1' : this.item.produto2_atividadeTodos,
                    produto2_atividadeSelecionados: this.item._produto2_atividadeSelecionados,
                    produto2_negociacaoPersonalizada: this.item.produto2_negociacaoPersonalizada,
                    produto2_idVigencia: this.item._produto2_idVigencia,
                    produto2_tipoNegociacao: this.item.produto2_tipoNegociacao
                };

                const exibeSpinnerOriginal = this.dbService.exibe_spinner;
                this.dbService.exibe_spinner = false;

                this.dbService.post('Assinatura/Assinar', temp).subscribe((result: RetornoAssinar) => {
                    this.dbService.exibe_spinner = exibeSpinnerOriginal;
                    this.spinnerService.stop();
                    this.retorno_assinar = result;

                    if (this.retorno_assinar.confirmacao === true) {
                        var posicao = this.carrinho.findIndex((s) => s.idProduto === this.etapa_produto);
                        if (posicao >= 0) {
                            this.carrinho.splice(posicao, 1);
                        }

                        let _carrinho = new Carrinho();
                        _carrinho.idProduto = this.etapa_produto;
                        _carrinho.dsProduto = this.obterNomeProdutoSelecionado(this.etapa_produto);
                        if (this.etapa_produto === 1) {
                            _carrinho.valor = this.produto1_precoSelecionado ? this.produto1_precoSelecionado.valor : 0;
                        } else if (this.etapa_produto === 2) {
                            _carrinho.valor = this.item._produto2_valor;
                        } else {
                            _carrinho.valor = 0;
                        }
                        this.carrinho.push(_carrinho);
                        this.idPedido = this.retorno_assinar.idPedido;
                        this.show_pagamento = true;
                    }
                }, error => {
                    this.dbService.exibe_spinner = exibeSpinnerOriginal;
                    console.error('Erro ao finalizar assinatura:', error);
                });
                return;
        }

        // Verifica se deve mover ainda dentro da etapa 2
        if (this.etapa === 2 && this.index_produto < this.item.produto_selecionado.length && this.etapa_produto !== 1) {
            this.etapa_produto = this.item.produto_selecionado[this.index_produto];
            this.index_produto += 1;
            return;
        }

        // Próxima etapa
        this.etapa += 1;
        this.etapa_progress += this.progress_step;

        // Trata etapas
        if (this.etapa === 2) {
            this.etapa_produto = this.item.produto_selecionado[0];
            this.index_produto = 1;
            this.fnCalcular();
        }

        // Se está autenticado, a etapa 3 vira a conferência dos dados fiscais (exceto solicitações
        // especiais, que não geram nota); nesse caso pula o cadastro.
        if (this.etapa === 3 && this.hashAtual() !== '') {
            if (this.exigeConfirmacaoFiscal()) {
                this.fnIniciarConfirmacaoFiscal();
            } else {
                this.etapa = 4;
                this.etapa_progress = 80;
            }
        } else if (this.etapa === 3) {
            this.limparCredenciaisCadastro();
            this.fiscal_confirmado = false;
            this.fiscal_tentouAvancar = false;
        }

        // Se o produto não requer termos, pula a etapa 4
        if (this.etapa === 4 && !this.requerTermos()) {
            this.etapa = 5;
            this.etapa_progress = 100;
            this.fnEtapaAvancar(); // Chama novamente para processar o pedido
        }
    }

    requerTermos(): boolean {
        return this.item.produto_selecionado[0] === 1 || 
               this.item.produto_selecionado[0] === 2 || 
               this.item.produto_selecionado[0] === 3 || 
               this.item.produto_selecionado[0] === 4 || 
               this.item.produto_selecionado[0] === 5;
    }

    fnEtapaVoltar() {
        this.etapa -= 1;
        this.etapa_progress -= this.progress_step;

        // Autenticado sem conferência fiscal (solicitações especiais): volta da etapa de termos para a 2
        if (this.etapa === 3 && this.hashAtual() !== '' && !this.exigeConfirmacaoFiscal()) {
            this.etapa = 2;
            this.etapa_progress = 40;
        }

        if (this.etapa === 1) {
            this.carrinho = [];
            this.item.produto_selecionado = [];
            this.etapa_produto = 0;
            this.index_produto = 0
        }

        // Trata etapas
        if (this.etapa === 2) {
            this.etapa_produto = this.item.produto_selecionado[0];
            this.index_produto = 1;
        }
    }

    private hashAtual(): string {
        return this.item.pessoal_hash || this.sessionService.usuario.hash || '';
    }

    exigeConfirmacaoFiscal(): boolean {
        return this.hashAtual() !== '' && this.item.produto_selecionado[0] !== 4;
    }

    private fnRetomarAposAutenticacao(): void {
        if (this.exigeConfirmacaoFiscal()) {
            this.etapa = 3;
            this.etapa_progress = 75;
            this.fnIniciarConfirmacaoFiscal();
        } else {
            this.etapa = 4;
            this.etapa_progress = 80;
        }
    }

    fnIniciarConfirmacaoFiscal(): void {
        this.fiscal_carregado = false;
        this.fiscal_editando = false;
        this.fiscal_confirmado = false;
        this.fiscal_tentouAvancar = false;
        this.fiscal_erro = '';
        this.dadosFiscaisBackup = null;
        this.fiscal_carregando = true;

        this.dbService.post('Cliente/AreaAssinante', JSON.stringify(this.hashAtual())).subscribe(result => {
            this.fiscal_carregando = false;
            this.fiscal_carregado = true;

            this.item.pessoal_nmCliente     = result.pessoal_nmCliente || '';
            this.item.pessoal_cdDocumento   = result.pessoal_cdDocumento || '1';
            this.item.pessoal_nuDocumento   = result.pessoal_nuDocumento || '';
            this.item.pessoal_dsOcupacao    = result.pessoal_dsOcupacao || '';
            this.item.pessoal_dsOrganizacao = result.pessoal_dsOrganizacao || '';
            this.item.pessoal_dsCEP         = result.pessoal_dsCEP || '';
            this.item.pessoal_dsEndereco    = result.pessoal_dsEndereco || '';
            this.item.pessoal_dsNumero      = result.pessoal_dsNumero || '';
            this.item.pessoal_dsComplemento = result.pessoal_dsComplemento || '';
            this.item.pessoal_dsBairro      = result.pessoal_dsBairro || '';
            this.item.pessoal_dsMunicipio   = result.pessoal_dsMunicipio || '';
            this.item.pessoal_dsEstado      = result.pessoal_dsEstado || '';
            this.item.pessoal_nuTelefone    = result.pessoal_nuTelefone || '';
            this.emailCadastro              = result.pessoal_dsEmail || '';

            this.fnSincronizarFormFiscal();
            this.cbxDocumento_Changed();
            this.tbxTelefone_Changed();

            // Dados obrigatórios ausentes ou inválidos: já abre a edição
            if (!this.dadosFiscaisValidos()) {
                this.fnEditarDadosFiscais();
                this.CONTROLES_FISCAIS.forEach(c => this.form_etapa3.controls[c].markAsTouched());
            }
        }, error => {
            this.fiscal_carregando = false;
            this.fiscal_erro = 'Não foi possível carregar os dados da nota fiscal. Tente novamente.';
        });
    }

    private fnSincronizarFormFiscal(): void {
        this.form_etapa3.patchValue({
            pessoal_nmCliente: this.item.pessoal_nmCliente,
            pessoal_cdDocumento: this.item.pessoal_cdDocumento,
            pessoal_nuDocumento: this.item.pessoal_nuDocumento,
            pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
            pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
            pessoal_dsCEP: this.item.pessoal_dsCEP,
            pessoal_dsEndereco: this.item.pessoal_dsEndereco,
            pessoal_dsNumero: this.item.pessoal_dsNumero,
            pessoal_dsComplemento: this.item.pessoal_dsComplemento,
            pessoal_dsBairro: this.item.pessoal_dsBairro,
            pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
            pessoal_dsEstado: this.item.pessoal_dsEstado,
            pessoal_nuTelefone: this.item.pessoal_nuTelefone
        });
    }

    private dadosFiscaisValidos(): boolean {
        return this.CONTROLES_FISCAIS.every(c => this.form_etapa3.controls[c].valid);
    }

    fnEditarDadosFiscais(): void {
        this.dadosFiscaisBackup = {};
        this.CONTROLES_FISCAIS.forEach(c => this.dadosFiscaisBackup[c] = this.item[c]);
        this.fiscal_editando = true;
        this.fiscal_confirmado = false;
        this.fiscal_tentouAvancar = false;
        this.fiscal_erro = '';
    }

    fnCancelarEdicaoFiscal(): void {
        if (this.dadosFiscaisBackup) {
            Object.assign(this.item, this.dadosFiscaisBackup);
            this.fnSincronizarFormFiscal();
            this.cbxDocumento_Changed();
            this.dadosFiscaisBackup = null;
        }
        this.fiscal_editando = false;
        this.fiscal_erro = '';
    }

    fnSalvarDadosFiscais(): void {
        this.fiscal_erro = '';
        if (!this.dadosFiscaisValidos()) {
            this.CONTROLES_FISCAIS.forEach(c => this.form_etapa3.controls[c].markAsTouched());
            this.fiscal_erro = 'Corrija os campos destacados para salvar.';
            return;
        }

        const payload = {
            pessoal_nmCliente: this.item.pessoal_nmCliente,
            pessoal_cdDocumento: this.item.pessoal_cdDocumento,
            pessoal_nuDocumento: this.item.pessoal_nuDocumento,
            pessoal_dsOcupacao: this.item.pessoal_dsOcupacao,
            pessoal_dsOrganizacao: this.item.pessoal_dsOrganizacao,
            pessoal_dsCEP: this.item.pessoal_dsCEP,
            pessoal_dsEndereco: this.item.pessoal_dsEndereco,
            pessoal_dsNumero: this.item.pessoal_dsNumero,
            pessoal_dsComplemento: this.item.pessoal_dsComplemento,
            pessoal_dsBairro: this.item.pessoal_dsBairro,
            pessoal_dsMunicipio: this.item.pessoal_dsMunicipio,
            pessoal_dsEstado: this.item.pessoal_dsEstado,
            pessoal_nuTelefone: this.item.pessoal_nuTelefone,
            pessoal_dsEmail: this.emailCadastro,
            pessoal_cdSenha: '',
            pessoal_cdSenha1: ''
        };

        this.fiscal_salvando = true;
        this.dbService.post('Cliente/AtualizarDadosCadastrais/?hash=' + this.hashAtual(), payload).subscribe(result => {
            this.fiscal_salvando = false;
            if (result.confirmacao === true) {
                this.fiscal_editando = false;
                this.fiscal_confirmado = false;
                this.dadosFiscaisBackup = null;
            } else {
                this.fiscal_erro = 'Não foi possível salvar os dados. Tente novamente.';
            }
        }, error => {
            this.fiscal_salvando = false;
            this.fiscal_erro = 'Não foi possível salvar os dados. Tente novamente.';
        });
    }

    private fnPodeAvancarDadosFiscais(): boolean {
        if (!this.fiscal_carregado) {
            if (!this.fiscal_carregando && this.fiscal_erro === '') {
                this.fnIniciarConfirmacaoFiscal();
            }
            return false;
        }

        if (this.fiscal_editando) {
            this.fiscal_erro = 'Salve ou cancele a alteração dos dados fiscais para continuar.';
            return false;
        }

        if (!this.dadosFiscaisValidos()) {
            this.fnEditarDadosFiscais();
            this.CONTROLES_FISCAIS.forEach(c => this.form_etapa3.controls[c].markAsTouched());
            return false;
        }

        if (!this.fiscal_confirmado) {
            this.fiscal_tentouAvancar = true;
            return false;
        }

        return true;
    }

    fnFiscalConfirmadoChanged(): void {
        this.fiscal_tentouAvancar = false;
    }

    get fiscal_documentoFormatado(): string {
        const d = (this.item.pessoal_nuDocumento || '').replace(/\D/g, '');
        if (d.length === 11) {
            return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
        if (d.length === 14) {
            return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
        return this.item.pessoal_nuDocumento;
    }

    private limparCredenciaisCadastro(): void {
        this.item.pessoal_dsEmail = '';
        this.item.pessoal_cdSenha = '';
        this.form_etapa3.patchValue({
            pessoal_dsEmail: '',
            pessoal_cdSenha: ''
        });
    }

    private obterNomeProdutoSelecionado(idProduto: number): string {
        if (idProduto === 1) {
            const nomeBase = 'Pesquisa Salarial';

            if (this.item.produto1_tipoPesquisa === '1') {
                return nomeBase + ' - Salario Mensal';
            }

            if (this.item.produto1_tipoPesquisa === '2') {
                return nomeBase + ' - Salario Hora';
            }

            if (this.item.produto1_tipoPesquisa === '3') {
                return nomeBase + ' - Salario Mensal e Salario Hora';
            }

            return nomeBase;
        }

        if (idProduto === 2) {
            const tipoSelecionado = this.lista_tipoNegociacao.find((tipo) => tipo.value === this.item.produto2_tipoNegociacao);
            return tipoSelecionado ? tipoSelecionado.text : 'Negociação Coletiva';
        }

        const produto = this.lista_produto.find((p) => p.idProduto === idProduto);
        return produto ? produto.dsProduto : '';
    }

    fnProduto2Adicionar_Atividade() {
        if (!this.form_etapa2_2_2.valid) {
            for (let ctrl in this.form_etapa2_2_2.controls) {
                this.form_etapa2_2_2.controls[ctrl].markAsTouched();
            }
        } else {
            let atividadeSelecionada = this.lista_atividade.find(s => s.idAtividade === this.item.produto2_idAtividade);
            let shouldRecalculate = false;
    
            if (atividadeSelecionada.icNaoClicavel) {
                let atividadesParaAdicionar = this.lista_atividade.filter(a =>
                    a.idSetor === atividadeSelecionada.idSetor &&
                    !a.icTotalizador &&
                    !a.icNaoClicavel &&
                    !this.item.produto2_atividadeSelecionados.some(sa => sa.idAtividade === a.idAtividade)
                );
                if (atividadesParaAdicionar.length > 0) {
                    this.item.produto2_atividadeSelecionados.push(...atividadesParaAdicionar);
                    shouldRecalculate = true;
                }
            } else {
                if (!this.item.produto2_atividadeSelecionados.some(s => s.idAtividade === atividadeSelecionada.idAtividade)) {
                    this.item.produto2_atividadeSelecionados.push(atividadeSelecionada);
                    shouldRecalculate = true;
                } else {
                    this.etapa_erro = 2;
                    return;
                }
            }
    
            if (shouldRecalculate) {
                this.item.alteracao_produto2_atividade.next();  // Trigger the calculation
            }
        }
    }    


    fnProduto2Adicionar_UF() {
        if (!this.form_etapa2_2_1.valid) {
            for (let ctrl in this.form_etapa2_2_1.controls) {
                this.form_etapa2_2_1.controls[ctrl].markAsTouched();
            }
        } else {
            let ufSelecionada = this.lista_uf.find(s => s.cdUf === this.item.produto2_cdUf);
            let shouldRecalculate = false;
    
            if (ufSelecionada.icNaoClicavel) {
                let ufsParaAdicionar = this.lista_uf.filter(uf =>
                    uf.idRegiao === ufSelecionada.idRegiao &&
                    !uf.icTotalizador &&
                    !uf.icNaoClicavel &&
                    !this.item.produto2_ufSelecionados.some(su => su.cdUf === uf.cdUf)
                );
                if (ufsParaAdicionar.length > 0) {
                    this.item.produto2_ufSelecionados.push(...ufsParaAdicionar);
                    shouldRecalculate = true;
                }
            } else {
                if (!this.item.produto2_ufSelecionados.some(s => s.cdUf === ufSelecionada.cdUf)) {
                    this.item.produto2_ufSelecionados.push(ufSelecionada);
                    shouldRecalculate = true;
                } else {
                    this.etapa_erro = 1;
                    return;
                }
            }
    
            if (shouldRecalculate) {
                this.item.alteracao_produto2_uf.next();  // Trigger the calculation
            }
        }
    }    
    

    fnProduto2Remover_Atividade(idAtividade: number) {
        this.etapa_erro = 0;
        this.item.produto2_atividadeSelecionados = this.item.produto2_atividadeSelecionados.filter((s) => s.idAtividade !== idAtividade);
    }

    fnProduto2Remover_UF(cdUf: number) {
        this.etapa_erro = 0;
        this.item.produto2_ufSelecionados = this.item.produto2_ufSelecionados.filter((s) => s.cdUf !== cdUf);
    }

    fnSelecionarProduto(idProduto: number) {

        this.carrinho = [];
        this.item.produto_selecionado = [];
        this.etapa_produto = idProduto;
    
        this.item.produto_selecionado.push(idProduto);

        let _carrinho = new Carrinho();
        _carrinho.idProduto = idProduto;
        _carrinho.dsProduto = this.lista_produto.filter((s) => s.idProduto === idProduto)[0].dsProduto;
        _carrinho.valor = 0;
        this.carrinho.push(_carrinho);

        this.etapa += 1;
        this.fnEtapaAvancar();

    }

    fnVoltar() {
        // Manda para home
        this.router.navigate(['/home']);
    }

    ValidaEmail(): AsyncValidatorFn {
        return (control: AbstractControl): Promise<ValidationErrors | null> => {
            return new Promise (resolve => {
                resolve(null);
            });
        };
    }

    fnEmailChanged(etapa: number = 0) {
        // Se foi chamado pelo modal de login
        if (etapa !== 0) {
            const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario'));
            if (sessao !== null) {
                this.fnRestaurarContextoCompra();

                // Atualiza o hash do usuário logado para que a chamada de Assinar
                // identifique corretamente o assinante no backend
                if (sessao.hash) {
                    this.item.pessoal_hash = sessao.hash;
                }
                this.emailExistente = false;

                // Mantém a mesma estratégia do fluxo OTP: após autenticar, retoma
                // a compra com o contexto restaurado.
                this.fnRetomarAposAutenticacao();
                sessionStorage.removeItem(this.CONTEXTO_COMPRA_KEY);
            }
            return;
        }

        // Verifica se o e-mail foi preenchido e é válido
        if (this.item.pessoal_dsEmail && this.item.pessoal_dsEmail.trim() !== '') {

            this.dbService.post('Cliente/VerificarEmail/?hash=' + '', JSON.stringify(this.item.pessoal_dsEmail)).subscribe(result => {
                if (result.emailDisponivel === true) {
                    this.emailExistente = false;
                } else {
                    this.emailExistente = true;
                    this.fnAbrirLoginCompra();
                }
            }, error => {
                console.error('Erro ao verificar e-mail:', error);
            });
        }
    }

    ValidaCPFCNPJ(): ValidatorFn {
        return (control: AbstractControl) => {
            // Usa o valor do control, não do item
            const valorDocumento = control.value;
            
            // Se o campo estiver vazio, retorna erro de obrigatório
            if (!valorDocumento || valorDocumento.toString().trim() === '') {
                return { required: true };
            }

            var strCPFCNPJ = valorDocumento.toString();
            strCPFCNPJ = strCPFCNPJ.replace(/[^\d]+/g,'');

            // Se não tiver dígitos após remover caracteres não numéricos, retorna erro
            if (!strCPFCNPJ || strCPFCNPJ.length === 0) {
                return { required: true };
            }

            if (strCPFCNPJ.length == 11)
            {
                var soma;
                var resto;
                soma = 0;

                if (strCPFCNPJ == "00000000000" || 
                    strCPFCNPJ == "11111111111" || 
                    strCPFCNPJ == "22222222222" || 
                    strCPFCNPJ == "33333333333" || 
                    strCPFCNPJ == "44444444444" || 
                    strCPFCNPJ == "55555555555" || 
                    strCPFCNPJ == "66666666666" || 
                    strCPFCNPJ == "77777777777" || 
                    strCPFCNPJ == "88888888888" || 
                    strCPFCNPJ == "99999999999")
                    return { invalido: true }
                
                for (var i=1; i<=9; i++) soma = soma + parseInt(strCPFCNPJ.substring(i-1, i)) * (11 - i);
                
                resto = (soma * 10) % 11;
                    
                if ((resto == 10) || (resto == 11))  resto = 0;
                if (resto != parseInt(strCPFCNPJ.substring(9, 10)) ) return { invalido: true }
                    
                soma = 0;
                for (i = 1; i <= 10; i++) soma = soma + parseInt(strCPFCNPJ.substring(i-1, i)) * (12 - i);
                resto = (soma * 10) % 11;
                    
                if ((resto == 10) || (resto == 11))  resto = 0;
                if (resto != parseInt(strCPFCNPJ.substring(10, 11) ) ) return { invalido: true }

                return null;
            

            } else if (strCPFCNPJ.length == 14) {

                if (strCPFCNPJ == "00000000000000" || 
                    strCPFCNPJ == "11111111111111" || 
                    strCPFCNPJ == "22222222222222" || 
                    strCPFCNPJ == "33333333333333" || 
                    strCPFCNPJ == "44444444444444" || 
                    strCPFCNPJ == "55555555555555" || 
                    strCPFCNPJ == "66666666666666" || 
                    strCPFCNPJ == "77777777777777" || 
                    strCPFCNPJ == "88888888888888" || 
                    strCPFCNPJ == "99999999999999")
                    return { invalido: true }

                // Aceita receber o valor como string, número ou array com todos os dígitos
                const isString = typeof strCPFCNPJ === 'string';
                const validTypes = isString;// || Number.isInteger(strCPFCNPJ) || Array.isArray(strCPFCNPJ);

                // Elimina valor em formato inválido
                if (!validTypes) return { invalido: true }

                // Filtro inicial para entradas do tipo string
                if (isString) {
                    // Limita ao máximo de 18 caracteres, para CNPJ formatado
                    if (strCPFCNPJ.length > 14) return { invalido: true }

                    // Teste Regex para veificar se é uma string apenas dígitos válida
                    const digitsOnly = /^\d{14}$/.test(strCPFCNPJ)
                    // Teste Regex para verificar se é uma string formatada válida
                    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(strCPFCNPJ)

                    // Se o formato é válido, usa um truque para seguir o fluxo da validação
                    if (digitsOnly || validFormat) true
                    // Se não, retorna inválido
                    else return { invalido: true }
                }

                // Guarda um array com todos os dígitos do valor
                const match = strCPFCNPJ.toString().match(/\d/g)
                const numbers = Array.isArray(match) ? match.map(Number) : []

                // Valida a quantidade de dígitos
                if (numbers.length !== 14) return { invalido: true }
                
                // Elimina inválidos com todos os dígitos iguais
                const items = Array.from(numbers);
                if (items.length === 1) return { invalido: true }

                // Cálculo validador
                const calc = (x) => {
                    const slice = numbers.slice(0, x)
                    let factor = x - 7
                    let sum = 0

                    for (let i = x; i >= 1; i--) {
                    const n = slice[x - i]
                    sum += n * factor--
                    if (factor < 2) factor = 9
                    }

                    const result = 11 - (sum % 11)

                    return result > 9 ? 0 : result
                }

                // Separa os 2 últimos dígitos de verificadores
                const digits = numbers.slice(12)
                
                // Valida 1o. dígito verificador
                const digit0 = calc(12)
                if (digit0 !== digits[0]) return { invalido: true }

                // Valida 2o. dígito verificador
                const digit1 = calc(13)
                if (digit1 !== digits[1]) return { invalido: true }
                    
                return null;
            } else {
                // Se não tem 11 nem 14 dígitos, é inválido
                return { invalido: true };
            }
        }
    }

    ValidaProduto1(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            if (this.item.produto1_municipioTodos === '1') {
                return null;
            } else if (this.item.produto1_municipioTodos === '0' && (this.item.produto1_municipioSelecionados === null || this.item.produto1_municipioSelecionados.length === 0)) {
                return { invalido: true }
            }
    
            return null;
        };
    }

    ValidaProduto2(campo: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} => {
            // Se for Boletim (value="5"), não valida estado e atividade
            if (this.item.produto2_tipoNegociacao === '5') {
                return null;
            }

            switch (campo)
            {
                case 1:
                    if (this.item.produto2_ufTodos === '1') {
                        return null;
                    } else if (this.item.produto2_ufTodos === '0' && (this.item.produto2_ufSelecionados === null || this.item.produto2_ufSelecionados.length === 0)) {
                        return { invalido: true }
                    }
            
                    return null;

                case 2:
                    if (this.item.produto2_atividadeTodos === '1') {
                        return null;
                    } else if (this.item.produto2_atividadeTodos === '0' && (this.item.produto2_atividadeSelecionados === null || this.item.produto2_atividadeSelecionados.length === 0)) {
                        return { invalido: true }
                    }
            
                    return null;
            }
        };
    }

    fnAddFile(){
        var input = (document.getElementById('control_comprovante') as HTMLInputElement);
        var arquivo = input.files[0];

        //if arquivo = 

        const fd = new FormData();
        fd.append(arquivo.name, arquivo); 
        fd.append("idPedido", this.retorno_assinar.idPedido)
            
        this.dbService.postFile("Assinatura/EnviaEmailComprovante", fd).subscribe((result: Comprovante) => {
            this.spinnerService.stop();

                this.enviado = 'ok'; 
        },
                err => {
                this.enviado = 'nok';

        });

    }

    fnChangeFile(){
        var input = (document.getElementById('control_comprovante') as HTMLInputElement);
        var arquivo = input.files[0];    
        document.getElementById('comprovante_texto').innerHTML = '<b style="color: #20a1fa;">' + arquivo.name + '</b>';
    }

    aceitarTermos() {
        if (this.requerTermos()) {
            this.item.pessoal_icTermo = true;
            this.etapa = 5;
            this.etapa_progress = 100;
            this.fnEtapaAvancar();
        }
    }

    rejeitarTermos() {
        if (this.requerTermos()) {
            this.etapa = 1;
            this.etapa_progress = 20;
            this.carrinho = [];
            this.item.produto_selecionado = [];
            this.etapa_produto = 0;
            this.index_produto = 0;
            this.item.pessoal_icTermo = false;
        }
    }

    ValorCielo(valor: number): string {
        return valor.toFixed(2).toString().replace(".", "");
    }

    cbxDocumento_Changed() {
        if (this.item.pessoal_cdDocumento === '1') {
            this.maskDocumento = "000.000.000-00";
        } else {
            this.maskDocumento = "00.000.000/0000-00";
        }
    }

    tbxTelefone_Blur() {
        if (this.item.pessoal_nuTelefone.trim().length === 10) {
            this.item.pessoal_nuTelefone += " ";
        }
    }

    tbxTelefone_Changed() {
        if (this.item.pessoal_nuTelefone.trim().length === 11) {
            this.mask = "(00) 00000-0009";
        } else {
            this.mask = "(00) 0000-00009";
        }
    }

    /* ===========================================================================================
     *  Edinaldo FIPE
     *  Dez/2020 
     *  Pesquisa o Logradouro pelo CEP
     ===========================================================================================*/
    fnCep(cep:string){
        cep = cep.replace(/ /gi , '');
        cep = cep.replace(/\-/gi, '');

        if (cep.length == 8) 
        {
            var sUrl = this.url_Cep + cep + '/json/'; 
            this.getCEPs(sUrl);
        }
    }    
    private getCEPs(url) {
        fetch(url)
          .then(res => res.json())
          .then(json => this.showContent(json))
      }
      
    private showContent(cep) {
        this.item.pessoal_dsCEP         = cep.cep;
        this.item.pessoal_dsEndereco    = cep.logradouro;
        this.item.pessoal_dsNumero      = '';
        this.item.pessoal_dsComplemento = '';
        this.item.pessoal_dsBairro      = cep.bairro;
        this.item.pessoal_dsMunicipio   = cep.localidade;
        this.item.pessoal_dsEstado      = cep.uf;
    }
}
